export default __webpack_public_path__ + "static/media/cloud-add.a7915c01.svg";